export default "__VITE_ASSET__WZRsInvY__"